"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderConfigResDtoToJSON = exports.OrderConfigResDtoFromJSONTyped = exports.OrderConfigResDtoFromJSON = exports.instanceOfOrderConfigResDto = exports.OrderConfigResDtoGroupTypeEnum = void 0;
var runtime_1 = require("../runtime");
var ClinicianDto_1 = require("./ClinicianDto");
var OrderConfigResDtoPatientDemographics_1 = require("./OrderConfigResDtoPatientDemographics");
var OrderConfigResTestSelectionTypeEnum_1 = require("./OrderConfigResTestSelectionTypeEnum");
var OrderConfigResVisibilityEnum_1 = require("./OrderConfigResVisibilityEnum");
var OrderConfigVerificationTypeEnum_1 = require("./OrderConfigVerificationTypeEnum");
var TestSelectionResDto_1 = require("./TestSelectionResDto");
/**
 * @export
 */
exports.OrderConfigResDtoGroupTypeEnum = {
    Account: 'ACCOUNT',
    Partnership: 'PARTNERSHIP'
};
/**
 * Check if a given object implements the OrderConfigResDto interface.
 */
function instanceOfOrderConfigResDto(value) {
    var isInstance = true;
    isInstance = isInstance && "enableBiPa" in value;
    isInstance = isInstance && "groupId" in value;
    isInstance = isInstance && "groupType" in value;
    isInstance = isInstance && "isActive" in value;
    isInstance = isInstance && "isLocked" in value;
    return isInstance;
}
exports.instanceOfOrderConfigResDto = instanceOfOrderConfigResDto;
function OrderConfigResDtoFromJSON(json) {
    return OrderConfigResDtoFromJSONTyped(json, false);
}
exports.OrderConfigResDtoFromJSON = OrderConfigResDtoFromJSON;
function OrderConfigResDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'attestation': !(0, runtime_1.exists)(json, 'attestation') ? undefined : json['attestation'],
        'billToClient': !(0, runtime_1.exists)(json, 'billToClient') ? undefined : json['billToClient'],
        'clinicianCountries': !(0, runtime_1.exists)(json, 'clinicianCountries') ? undefined : json['clinicianCountries'],
        'clinicianAccess': !(0, runtime_1.exists)(json, 'clinicianAccess') ? undefined : (json['clinicianAccess'].map(ClinicianDto_1.ClinicianDtoFromJSON)),
        'displayName': !(0, runtime_1.exists)(json, 'displayName') ? undefined : json['displayName'],
        'defaultDelegates': !(0, runtime_1.exists)(json, 'defaultDelegates') ? undefined : json['defaultDelegates'],
        'selectedWorkflows': !(0, runtime_1.exists)(json, 'selectedWorkflows') ? undefined : json['selectedWorkflows'],
        'enableBiPa': json['enableBiPa'],
        'endDate': !(0, runtime_1.exists)(json, 'endDate') ? undefined : json['endDate'],
        'groupId': json['groupId'],
        'groupType': json['groupType'],
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'isActive': json['isActive'],
        'isLocked': json['isLocked'],
        'landingPageUrl': !(0, runtime_1.exists)(json, 'landingPageUrl') ? undefined : json['landingPageUrl'],
        'patientDemographics': !(0, runtime_1.exists)(json, 'patientDemographics') ? undefined : (0, OrderConfigResDtoPatientDemographics_1.OrderConfigResDtoPatientDemographicsFromJSON)(json['patientDemographics']),
        'paymentMethods': !(0, runtime_1.exists)(json, 'paymentMethods') ? undefined : json['paymentMethods'],
        'startDate': !(0, runtime_1.exists)(json, 'startDate') ? undefined : json['startDate'],
        'surveyUrl': !(0, runtime_1.exists)(json, 'surveyUrl') ? undefined : json['surveyUrl'],
        'testSelectionType': !(0, runtime_1.exists)(json, 'testSelectionType') ? undefined : (0, OrderConfigResTestSelectionTypeEnum_1.OrderConfigResTestSelectionTypeEnumFromJSON)(json['testSelectionType']),
        'testSelections': !(0, runtime_1.exists)(json, 'testSelections') ? undefined : (json['testSelections'] === null ? null : json['testSelections'].map(TestSelectionResDto_1.TestSelectionResDtoFromJSON)),
        'visibility': !(0, runtime_1.exists)(json, 'visibility') ? undefined : (0, OrderConfigResVisibilityEnum_1.OrderConfigResVisibilityEnumFromJSON)(json['visibility']),
        'verificationType': !(0, runtime_1.exists)(json, 'verificationType') ? undefined : (0, OrderConfigVerificationTypeEnum_1.OrderConfigVerificationTypeEnumFromJSON)(json['verificationType']),
    };
}
exports.OrderConfigResDtoFromJSONTyped = OrderConfigResDtoFromJSONTyped;
function OrderConfigResDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attestation': value.attestation,
        'billToClient': value.billToClient,
        'clinicianCountries': value.clinicianCountries,
        'clinicianAccess': value.clinicianAccess === undefined ? undefined : (value.clinicianAccess.map(ClinicianDto_1.ClinicianDtoToJSON)),
        'displayName': value.displayName,
        'defaultDelegates': value.defaultDelegates,
        'selectedWorkflows': value.selectedWorkflows,
        'enableBiPa': value.enableBiPa,
        'endDate': value.endDate,
        'groupId': value.groupId,
        'groupType': value.groupType,
        'id': value.id,
        'isActive': value.isActive,
        'isLocked': value.isLocked,
        'landingPageUrl': value.landingPageUrl,
        'patientDemographics': (0, OrderConfigResDtoPatientDemographics_1.OrderConfigResDtoPatientDemographicsToJSON)(value.patientDemographics),
        'paymentMethods': value.paymentMethods,
        'startDate': value.startDate,
        'surveyUrl': value.surveyUrl,
        'testSelectionType': (0, OrderConfigResTestSelectionTypeEnum_1.OrderConfigResTestSelectionTypeEnumToJSON)(value.testSelectionType),
        'testSelections': value.testSelections === undefined ? undefined : (value.testSelections === null ? null : value.testSelections.map(TestSelectionResDto_1.TestSelectionResDtoToJSON)),
        'visibility': (0, OrderConfigResVisibilityEnum_1.OrderConfigResVisibilityEnumToJSON)(value.visibility),
        'verificationType': (0, OrderConfigVerificationTypeEnum_1.OrderConfigVerificationTypeEnumToJSON)(value.verificationType),
    };
}
exports.OrderConfigResDtoToJSON = OrderConfigResDtoToJSON;
